<template>
  <el-menu :default-active="active" router class="el-menu-vertical-demo">
    <el-menu-item :index="bookShelfMenu.path" :key="bookShelfMenu.name" @click="openTab(bookShelfMenu)">
      <i :class="bookShelfMenu.icon"></i>
      <span>书架</span>
    </el-menu-item>
    <el-submenu v-for="menu in menuArr" :index="menu.path" :key="menu.name">
      <template #title>
        <i :class="menu.icon"></i>
        <span>{{menu.name}}</span>
      </template>
      <el-menu-item class="menu-item-item" v-for="cMenu in menu.children" :index="cMenu.path" :key="cMenu.name" @click="openTab(cMenu)">
        <i :class="cMenu.icon"></i>
        <span>{{cMenu.name}}</span>
      </el-menu-item>
    </el-submenu>
  </el-menu>
</template>

<script>
export default {
  name: 'leftBar',
  data () {
    return {
      active: '/bookShelf',
      bookShelfMenu: {name: '书架', path: '/bookShelf', icon: 'el-icon-reading'},
      menuArr: [
        {
          name: '教材管理', path: '1', icon: 'el-icon-notebook-2', children: [{name: '书籍管理', path: '/bookManagement', icon: 'el-icon-notebook-1'}, {name: '内容管理', path: '/contentManagement', icon: 'el-icon-files'}]
        },
        {
          name: '密钥管理', path: '2', icon: 'el-icon-search', children: [{name: '激活码管理', path: '/authCodeManagement', icon: 'el-icon-key'}]
        }
      ]
    }
  },
  watch: {
    '$store.state.tab.editableTabsValue': {
      handler: function () {
        this.active = this.$store.state.tab.editableTabsValue
      }
    }
  },
  methods: {
    openTab (item) {
      this.$store.commit('add_tabs', item)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/home/leftBar.vue